import { Attachment } from "airtable"
import { MediaAdditional } from "../media"

interface DetailImagesProps {
  detail_images: Attachment[]
}

const DetailImages = (props: DetailImagesProps) => {
  const { detail_images } = props

  const Detail = (item: any) => {
    return (
      <li>
        <MediaAdditional {...item} zoom={true} width={100} height={100} />
      </li>
    )
  }

  if (!!detail_images) {
    return (
      <ul tw="flex space-x-4">
        {detail_images.map((item: any, i: number) => {
          return <Detail {...item} key={i} />
        })}
      </ul>
    )
  }
  return <></>
}

export default DetailImages
